"use client";

import { useEffect, useState } from "react";
import {
  KEY,
  PERPETUAL_TOKEN,
  REQ_DATA,
  TOKEN,
} from "../constants/sso.constants";
import {
  doesExist,
  getCookie,
  getParams,
} from "@repo/shared-utils/common-utils";
import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import dynamic from "next/dynamic";
import Conditional from "@repo/shared-ui/Conditional";
import { setLoginStatus, useAppDispatch } from "@repo/web-store";
import { COMMON_SSO_ACCESS_TOKEN } from "@repo/shared-utils/sso.constants";

const InitSSO = dynamic(() => import("./InitSSO.tsx") as any, { ssr: false });

const SSO = () => {
  const dispatch = useAppDispatch();
  const [loadSSO, setLoadSSO] = useState(false);

  // effect
  useEffect(() => {
    shouldLoadSSO();
  }, []);

  /**
   * shouldLoadSSO
   */
  const shouldLoadSSO = () => {
    const hasAccessToken = doesExist(
      localStorage.getItem(COMMON_SSO_ACCESS_TOKEN),
    );
    const hasPToken = doesExist(getCookie(PERPETUAL_TOKEN));
    const hasFederatedToken = doesExist(getParams(TOKEN));
    const hasFederatedKeyParam = doesExist(getParams(KEY));
    const hasReqData = doesExist(getParams(REQ_DATA));

    if (
      isOpenInApp() ||
      hasAccessToken ||
      hasPToken ||
      hasFederatedToken ||
      hasFederatedKeyParam ||
      hasReqData
    ) {
      setLoadSSO(true);
    } else {
      dispatch(setLoginStatus({ loginStatus: "failure" }));
    }
  };

  return (
    <Conditional if={loadSSO}>
      <InitSSO />
    </Conditional>
  );
};

export default SSO;
